import { Suspense } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { BrandMark } from '../components/ui';
import { RouteErrorBoundary } from '../components/ErrorBoundary';
import { PageLoader } from '../components/SuspenseFallback';
import { SkipToContent } from '../utils/accessibility';

const LEGAL_LINKS = [
  { label: 'Syarat & Ketentuan', to: '/syarat' },
  { label: 'Kebijakan Privasi', to: '/privasi' },
  { label: 'Kebijakan Refund', to: '/refund' },
];

/**
 * Login and register. Wordmark only in the header — nav there would invite
 * someone to wander off mid-`lanjut`, and the `lanjut` param is the whole
 * reason they arrived. The footer stays: legal links, not navigation, so it
 * does not tempt the same detour, and without it these two screens were the
 * only ones in the product with no way to reach the legal pages at all.
 */
export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <SkipToContent />
      <header className="border-b-2 border-surface-2">
        <div className="mx-auto flex h-[74px] max-w-[1180px] items-center px-5 md:px-16">
          <Link
            to="/"
            className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink"
            aria-label="Jualan, Lapak Bang Ade. Ke beranda"
          >
            <BrandMark />
          </Link>
        </div>
      </header>
      <main id="main-content" className="flex-1 px-5 py-12 md:flex md:items-center md:justify-center md:px-16">
        <div className="mx-auto w-full max-w-[420px]">
          <RouteErrorBoundary>
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </RouteErrorBoundary>
        </div>
      </main>
      <footer className="border-t-2 border-surface-2">
        <div className="mx-auto flex max-w-[1180px] flex-col items-center gap-1 px-5 py-6 text-center md:flex-row md:justify-between md:px-16 md:text-left">
          <p className="text-[13px] font-semibold text-muted">
            &copy; {new Date().getFullYear()} Jualan Lapak Bang Ade
          </p>
          <nav aria-label="Tautan legal" className="flex flex-wrap justify-center gap-x-5">
            {LEGAL_LINKS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="inline-flex min-h-[44px] items-center text-[13px] font-semibold text-body no-underline transition-colors duration-150 ease-out hover:text-link-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </footer>
    </div>
  );
}

export default AuthLayout;
